<template>
    <div class="container-fluid">
        <div class="c-sidebar-tiny">
            <div class="c-sidebar-tiny__inner">
                <ul>
                    <router-link v-if="permissions('monitoring_place')" to="/monitoring/data" v-slot="{href, isActive}">
                        <li :class="[isActive ? 'active' : '']">
                            <a :href="href">
                                <i class="fa fa-eye"></i>
                                Quan trắc
                            </a>
                        </li>
                    </router-link>
                    <router-link v-if="permissions('monitoring_place')" to="/monitoring/place" v-slot="{href, isActive}">
                        <li :class="[isActive ? 'active' : '']">
                            <a :href="href">
                                <i class="fa fa-map"></i>
                                Vị trí quan trắc
                            </a>
                        </li>
                    </router-link>
                    <router-link v-if="permissions('monitoring_target')" to="/monitoring/target" v-slot="{href, isActive}">
                        <li :class="[isActive ? 'active' : '']">
                            <a :href="href">
                                <i class="fa fa-signal"></i>
                                Chỉ tiêu quan trắc
                            </a>
                        </li>
                    </router-link>
                    <router-link v-if="permissions('monitoring_target')" to="/monitoring/standard" v-slot="{href, isActive}">
                        <li :class="[isActive ? 'active' : '']">
                            <a :href="href">
                                <i class="fa fa-cogs"></i>
                                Quy chuẩn (QCVN)
                            </a>
                        </li>
                    </router-link>
                    <!-- <router-link v-if="permissions('monitoring_classify')" to="/monitoring/classify" v-slot="{href, isActive}">
                        <li :class="[isActive ? 'active' : '']">
                            <a :href="href">
                                <i class="fa fa-file-alt"></i>
                                Phân loại rác
                            </a>
                        </li>
                    </router-link>
                    <router-link v-if="permissions('monitoring_trash')" to="/monitoring/trash" v-slot="{href, isActive}">
                        <li :class="[isActive ? 'active' : '']">
                            <a :href="href">
                                <i class="fa fa-trash"></i>
                                Loại rác
                            </a>
                        </li>
                    </router-link> -->
                </ul>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import $ from 'jquery';
    import role from '@/mixins/Role';

    export default {
        mixins: [role],
        monitoring: function () {
            return {
                client: this.$store.state.client
            };
        },
        mounted: function () {
            //js expand menu setting
            $('.js-btn-mobile').on('click', function (e) {
                e.preventDefault();
                var sidebar = $('.c-sidebar-main');
                if (sidebar.hasClass('active')) {
                    sidebar.removeClass('active').slideUp();
                } else {
                    sidebar.addClass('active').slideDown();
                }
            });

            //close setting menu in mobile
            $('.c-sidebar-menu a').on('click', function (e) {
                var sidebar = $('.c-sidebar-main');
                var viewportGlobal = $(window).width();
                if (e.target == this && viewportGlobal < 768) {
                    sidebar.removeClass('active').slideUp();
                }
            });
        }
    }
</script>